/** Stored on the profile object in localStorage under key `admin` */
export const ADMIN_ROLE_SUPER = 'super-admin';
export const ADMIN_ROLE_COMPANY = 'admin';

/**
 * Maps app `modulePath` / `ModuleGuard` keys to tracker API `module_name`.
 * NavConfig uses plural paths for some items (`leads`, `orders`, …); routes may use shorter keys — include both.
 */
export const APP_MODULE_TO_TRACKER_NAME = {
  inventory: 'product',
  campaign: 'campaign',
  lead: 'lead',
  leads: 'lead',
  order: 'order',
  orders: 'order',
  invoice: 'invoice',
  vendor: 'vendor',
  discount: 'discount',
  employees: 'employees',
  employee: 'employees',
  designations: 'designation',
  designation: 'designation',
  route: 'routes',
  package: 'packages',
  packageList: 'packages',
  unit: 'unit',
  region: 'region_master',
  regionList: 'region_master',
};
